import { scrollLock, scrollUnlock } from 'utils/scrollLock'

class Modal {
  _state = {
    isOpen: false,
    iframe: null
  }

  constructor(element, options = {}) {
    this._element = element
    this._options = { ...options, ...Modal.options }
    this._cacheSelectors()
    this._init()
  }

  _cacheSelectors() {
    this._toggle = [...document.querySelectorAll('.modal-trigger')]
    this._close = this._element.querySelector('.button--close')
    this._iframe = this._element.querySelector('iframe')
    this._body = document.body
    this._html = document.documentElement
  }

  _init() {
    const src = this._iframe ? this._iframe.getAttribute('data-src') : null
    this._state.iframe = src
    if (src) {
      this._iframe.setAttribute('src', '')
    }
    this._addListeners()
  }

  _addListeners() {
    this._toggle.forEach(toggle =>
      toggle.addEventListener('click', () => this._handleToggle())
    )
    this._close.addEventListener('click', e => this._handleClose(e))
  }

  _handleClose(e) {
    e.preventDefault()
    this._element.setAttribute('aria-hidden', 'true')
    this._body.setAttribute('data-modal', false)
    this._body.scrollTop = this._html.scrollTop = this._state.scrollTop

    if (this._state.iframe) {
      this._iframe.setAttribute('src', '')
    }
    this._state.isOpen = false
  }

  _handleToggle() {
    this._body.setAttribute('data-modal', true)
    this._element.setAttribute('aria-hidden', 'false')
    this._state.scrollTop = this._body.scrollTop || this._html.scrollTop
    if (!this._state.isOpen && this._state.iframe) {
      this._iframe.setAttribute('src', this._state.iframe)
    }
    //eslint-disable-next-line
    this._state.open ? scrollLock() : scrollUnlock()
    this._state.isOpen = !this._state.isOpen
  }
}

export default Modal
